<div class="form-group">
  <label *ngIf="label" part="label" class="font-weight-bold">
    {{ label }}<span *ngIf="required" class="user-select-none text-danger">&nbsp;*</span>
  </label>
  <div class="custom-control custom-checkbox margin-bottom" *ngIf="showSelectAll">
    <input type="checkbox" id="selectAll" name="selectAll" class="custom-control-input" (change)="onSelectAllCheckboxChanged($event)">
    <label class="custom-control-label font-weight-bold" [attr.for]="'selectAll'">Select All</label>
  </div>
  <ul
    #list
    part="control"
    class="checkbox-list rounded list-group list-group-flush"
    [attr.touched]="touched ?? null"
    [attr.was-validated]="wasValidated ? true : null"
    [attr.invalid]="valid === false ? true : null">
    <ng-container *ngFor="let option of options; index as index">
      <li class="list-group-item list-group-item-action" role="checkbox" (click)="onListItemClicked($event)">
        <div class="custom-control custom-checkbox">
          <input
            #checkbox
            [attr.id]="'checkbox-' + index"
            class="custom-control-input"
            [attr.name]="index"
            type="checkbox"
            gpeiCheckboxListItem
            [checked]="option.selected"
            [checkedValue]="option.checkedValue"
            [uncheckedValue]="option.uncheckedValue"
            (input)="onInput($event)" />
          <label class="custom-control-label font-weight-bold" [attr.for]="'checkbox-' + index">{{ option.label }}</label>
        </div>
      </li>
    </ng-container>
  </ul>
  <slot #slot (slotchange)="onSlottedContentChanged($event)"></slot>
  <p *ngIf="validationMessage && wasValidated && valid === false" part="validation-message" class="form-text text-danger">
    {{ validationMessage }}
  </p>
  <small *ngIf="description" part="description" class="form-text text-muted">
    {{ description }}
  </small>
</div>
